import { Pipe, PipeTransform } from '@angular/core';
import { NOTIFICATION_CONSTANT } from '@client/app/modules/notifications/constant/notification.constant';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
    name: 'notificationName',
    standalone: true,
    pure: false,
})
export class NotificationNamePipe implements PipeTransform {
    constructor (
        private readonly translocoService: TranslocoService,
    ) {}

    transform (args: [string, Record<string, unknown>, string]): string {
        const [target, payload, action] = args;
        switch (target) {
            case NOTIFICATION_CONSTANT.TARGET.SEO_PAGE_ISSUE:
                return this.translocoService.translate('notifications.names.seoIssueStatus');
            case NOTIFICATION_CONSTANT.TARGET.ACCESSIBILITY_SOURCE_CODE:
                return this.translocoService.translate('notifications.names.accessibilityFor', { checkName: payload?.['check_name'] as string ?? '' });
            case NOTIFICATION_CONSTANT.TARGET.SPELLING_CONFIRMED:
                if (payload?.['word']) {
                    return this.translocoService.translate('notifications.names.confirmedMissSpellingWithWord', { word: payload['word'] as string });
                }
                return this.translocoService.translate('notifications.names.confirmedMissSpelling');
            case NOTIFICATION_CONSTANT.TARGET.SPELLING_DICTIONARY:
                if (payload?.['word']) {
                    return this.translocoService.translate('notifications.names.addedToDictionaryWithWord', { word: payload['word'] as string });
                }
                return this.translocoService.translate('notifications.names.wordToDictionary');
            case NOTIFICATION_CONSTANT.TARGET.LINK:
                return payload?.['link_url'] as string ?? '';
            case NOTIFICATION_CONSTANT.TARGET.SPELLING_IGNORED:
                return this.translocoService.translate('notifications.names.ignoredMissSpellingWithWord', { word: payload['word'] as string });
            case NOTIFICATION_CONSTANT.TARGET.EXPORT:
                return '';
            case NOTIFICATION_CONSTANT.TARGET.DOMAIN: {
                const domainTitle = payload['domain_title'] as string || '';

                if (action === NOTIFICATION_CONSTANT.ACTION.COOKIES_FOUND) {
                    const cookiesCount = payload['cookies_count'] as number;
                    return this.translocoService.translate('notifications.names.newCookiesOnDomain', { count: cookiesCount, domain: domainTitle });
                }

                if (domainTitle) {
                    return domainTitle;
                }

                return target;
            }
            case NOTIFICATION_CONSTANT.TARGET.ACCESSIBILITY_ERRORS_PAGE:
                return this.translocoService.translate('notifications.names.accessibilityErrorsFor', { domain: payload?.['domain_title'] as string ?? '' });
            case NOTIFICATION_CONSTANT.TARGET.ACCESSIBILITY_CHECK:
                return this.translocoService.translate('notifications.names.accessibilityCheck');
            case NOTIFICATION_CONSTANT.TARGET.ACCESSIBILITY_ERROR:
                return this.translocoService.translate('notifications.names.accessibilityError');
            case NOTIFICATION_CONSTANT.TARGET.PAGE:
                return this.translocoService.translate('notifications.names.page');
            default:
                return target;
        }
    }
}
